// A bilingual (English + Latin) Rosary-and-Scapular card that families can print and carry.
import { SCAPULAR_SOURCES } from "./scapular";
import { ROSARY_PRAYERS } from "./rosary";

export const ROSARY_SCAPULAR_CARD = {
  duplexSplit: 2,
  eyebrow: "A card to carry · English & Latin",
  title: "The Holy Rosary & the Brown Scapular",
  subtitle: "The essential prayers, the order of the beads, and the Carmelite sign of Our Lady",
  image: {
    src: "/images/treasury/our-lady-rosary.webp",
    alt: "Our Lady of the Rosary of Pompeii",
    credit: "Our Lady of the Rosary of Pompeii · Public domain",
  },
  blocks: [
    {
      label: "How to pray the Rosary",
      text: "On the crucifix: the Sign of the Cross and the Apostles' Creed. On the first bead, the Our Father; on the next three, a Hail Mary each; then the Glory Be. For each of the five mysteries: announce it, then pray one Our Father, ten Hail Marys, a Glory Be, and the Fátima Prayer. Close with the Hail, Holy Queen.",
    },
    {
      label: "Our Father · Pater Noster",
      text: `${ROSARY_PRAYERS.our_father.en}\n\n${ROSARY_PRAYERS.our_father.la}`,
    },
    {
      label: "Hail Mary · Ave Maria",
      text: `${ROSARY_PRAYERS.hail_mary.en}\n\n${ROSARY_PRAYERS.hail_mary.la}`,
    },
    {
      label: "Glory Be · Gloria Patri",
      text: `${ROSARY_PRAYERS.glory.en}\n\n${ROSARY_PRAYERS.glory.la}`,
    },
    {
      label: "The Fátima Prayer · after each decade",
      text: `${ROSARY_PRAYERS.fatima.en}\n\n${ROSARY_PRAYERS.fatima.la}`,
    },
    {
      label: "The Brown Scapular of Our Lady of Mount Carmel",
      text: "Through the Rosary and the Scapular she will save the world — a traditional devotional saying, paraphrased; attribution unverified. The Scapular is a sacramental, not a charm or an automatic guarantee: a sign of belonging to Mary and of following her Son. Ask a priest about the Church's blessing and enrolment.",
    },
  ],
  note: "Prayer on our lips and fidelity in our lives belong together. This card gathers traditional Catholic prayers; the Scapular reflection is optional and adds no beads or required prayers to the Rosary.",
  source: { label: "St. John Paul II · Rosarium Virginis Mariae (2002)", url: SCAPULAR_SOURCES.rosary },
  back: {
    eyebrow: "Under her mantle",
    name: "Our Lady of the Rosary · Our Lady of Mount Carmel",
    blessing: ROSARY_PRAYERS.hail_mary.en,
  },
  footer: "Theotokos · Mater Dei — Ad Iesum per Mariam",
};
